import ChatIcon from "./socialIcons/chatIcon.png";
import FBIcon from "./socialIcons/facebookIcon.png";
import InstagramIcon from "./socialIcons/instagramIcon.png";
import LinkedInIcon from "./socialIcons/linkedInIcon.png";
import YTIcon from "./socialIcons/utubeIcon.png";

const icons = [
  {
    icon: FBIcon,
    link: "https://www.facebook.com/covestro/?utm_medium=solutioncenter&utm_source=footer&utm_campaign=xbe_socialmedia-icons&utm_asset=0&utm_content=button_facebook_en",
    name: "Facebook",
  },
  {
    icon: InstagramIcon,
    link: "https://www.instagram.com/covestro/?utm_medium=solutioncenter&utm_source=footer&utm_campaign=xbe_socialmedia-icons&utm_asset=0&utm_content=button_instagram_en",
    name: "Instagram",
  },
  {
    icon: YTIcon,
    link: "https://www.youtube.com/c/Covestro",
    name: "Youtube",
  },
  {
    icon: LinkedInIcon,
    link: "https://www.linkedin.com/company/covestro/",
    name: "LinkedIn",
  },
  {
    icon: ChatIcon,
    link: "https://solutions.covestro.com/-/media/project/development/shared/images/logo/old_wechat-service-account_tag-solutioncenter.png?rev=647330d8c73c4191bb0d582f87039e97",
    name: "Chat",
  },
];

const productServices = [
  {
    text: "Product Finder",
    route: "https://solutions.covestro.com/en/products",
  },
  {
    text: "Product Safety First",
    route: "https://solutions.covestro.com/en/productsafetyfirst",
  },
  {
    text: "Order@Covestro",
    route: "https://www.order.covestro.com/order/index.jsp",
  },
  {
    text: "Covestro Direct Store",
    route: "https://directstore.covestro.com/",
  },
  {
    text: "Certificates",
    route: "https://solutions.covestro.com/en/certificates",
  },
  {
    text: "Career",
    route: "https://www.covestro.com/en/career",
  },
  {
    text: "Newsletter",
    route: "https://solutions.covestro.com/en/newsletter",
  },
  {
    text: "Covestro SpeakUp! Line",
    route:
      "https://secure.ethicspoint.eu/domain/media/en/gui/107997/index.html",
  },
];

const bottomFooter = [
  {
    text: "Terms & Conditions",
    route: "https://solutions.covestro.com/en/footersites/terms-and-conditions",
  },
  {
    text: "Disclaimer",
    route: "https://solutions.covestro.com/en/footersites/disclaimer",
  },
  {
    text: "Imprint",
    route: "https://solutions.covestro.com/en/footersites/imprint-page",
  },
  {
    text: "Privacy Statement",
    route: "https://solutions.covestro.com/en/footersites/privacy-statement",
  },
];

const EXTERNAL_PROVIDER_NAME = "OneLogin";
const INTERNAL_PROVIDER_NAME = "CovestroAzureSSO";
const SECRET_PROVIDER_NAME = "SECRET";

const ONE_LOGIN_URL =
  "https://covestro-test.onelogin.com/trust/saml2/http-redirect/sso/30b7a7a3-9d06-45e3-a582-0be66e1ac3b6";
const ONE_LOGIN_LOGOUT_URL =
  "https://covestro-test.onelogin.com/trust/saml2/http-redirect/slo/464018%22";

const AZURE_LOGIN_URL =
  "https://login.microsoftonline.com/0468bc4a-134c-4fb0-b843-a2a3d583e919/saml2";
const AZURE_LOGOUT_URL =
  "https://login.microsoftonline.com/0468bc4a-134c-4fb0-b843-a2a3d583e919/saml2";

const REGISTER_URL =
  "https://covestro.onelogin.com/self-registration2?name=SolutionCenter";

export {
  AZURE_LOGIN_URL as azureLoginUrl,
  AZURE_LOGOUT_URL as azureLogoutUrl,
  bottomFooter,
  EXTERNAL_PROVIDER_NAME as externalProviderName,
  INTERNAL_PROVIDER_NAME as internalProviderName,
  icons,
  ONE_LOGIN_LOGOUT_URL as oneLoginLogoutUrl,
  ONE_LOGIN_URL as oneLoginUrl,
  productServices,
  REGISTER_URL as registerUrl,
  SECRET_PROVIDER_NAME as secretProviderName,
};
